import share from "./share_icon_light_18px.png";

export const ShareIcon = () => <img src={share} alt="Share icon" />;
